export default "__VITE_ASSET__BLcIkCzZ__"